// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sectionComoFunciona_howtoContainer__81olc{
    position: relative;
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
}

.sectionComoFunciona_howtoTextTitle__AjuZ5{
    font-family: var(--goldplay-medium);
    font-size: 28px;
    font-weight: 500;
    line-height: 33px;
    color: #333333;
    text-align: center;
    padding-top: 50px;
}

.sectionComoFunciona_howtoTextTitle__AjuZ5 > span {
    color: var(--secundary)
}

.sectionComoFunciona_howtoSearchbar__OUZPp{
    display: flex;
    flex-direction: column;
}

.sectionComoFunciona_howtoSearchbar__OUZPp > picture {
    padding-top: 30px;
}

.sectionComoFunciona_imgBarraPesquisa__F83ZQ {
    width: auto;
    height: 22rem;
}

.sectionComoFunciona_howtoTextCenter__aPx7h{
    font-family: var(--goldplay-regular);
    font-weight: 400;
    font-size: 24px;
    text-align: center;
    padding: 30px;
}

.sectionComoFunciona_howtoImageMap__Eo2n9{
    display: inline-flex;
    align-self: center; 
    margin-left: 3rem;
    height: 36rem;
}

@media only screen and (min-width:1280px) {
    /* .howtoImageMap{
        height: 35rem;
    } */
}


@media only screen and (min-width: 1366px){}


@media only screen and (min-width: 1600px){}


@media only screen and (min-width:1920px){
    /* #vertical-1{
        transform: translate(4.0vw,-9.5vh);
    }

    .howtoTextLeft{
        transform: translate(4.0vw,-10.5vh);
    }

    #vertical-2{
        transform: translate(7.1vw,-9vh);
    }

    .howtoTextRight{
        transform: translate(-3.9vw,-9vh);
    } */

}

@media only screen and (min-width:2560px){
    /* #vertical-1{
        transform: translate(3.0vw,-7.5vh);
    }

    .howtoTextLeft{
        transform: translate(3.0vw,-7.5vh);
    }

    #vertical-2{
        transform: translate(5.4vw,-6.5vh);
    }

    .howtoTextRight{
        transform: translate(-2.9vw,-7vh);
    } */
}`, "",{"version":3,"sources":["webpack://./src/object/Section/comofunciona/sectionComoFunciona.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,mCAAmC;IACnC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,oCAAoC;IACpC,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI;;OAEG;AACP;;;AAGA,2CAA2C;;;AAG3C,2CAA2C;;;AAG3C;IACI;;;;;;;;;;;;;;OAcG;;AAEP;;AAEA;IACI;;;;;;;;;;;;;;OAcG;AACP","sourcesContent":[".howtoContainer{\n    position: relative;\n    display: inline-flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n}\n\n.howtoTextTitle{\n    font-family: var(--goldplay-medium);\n    font-size: 28px;\n    font-weight: 500;\n    line-height: 33px;\n    color: #333333;\n    text-align: center;\n    padding-top: 50px;\n}\n\n.howtoTextTitle > span {\n    color: var(--secundary)\n}\n\n.howtoSearchbar{\n    display: flex;\n    flex-direction: column;\n}\n\n.howtoSearchbar > picture {\n    padding-top: 30px;\n}\n\n.imgBarraPesquisa {\n    width: auto;\n    height: 22rem;\n}\n\n.howtoTextCenter{\n    font-family: var(--goldplay-regular);\n    font-weight: 400;\n    font-size: 24px;\n    text-align: center;\n    padding: 30px;\n}\n\n.howtoImageMap{\n    display: inline-flex;\n    align-self: center; \n    margin-left: 3rem;\n    height: 36rem;\n}\n\n@media only screen and (min-width:1280px) {\n    /* .howtoImageMap{\n        height: 35rem;\n    } */\n}\n\n\n@media only screen and (min-width: 1366px){}\n\n\n@media only screen and (min-width: 1600px){}\n\n\n@media only screen and (min-width:1920px){\n    /* #vertical-1{\n        transform: translate(4.0vw,-9.5vh);\n    }\n\n    .howtoTextLeft{\n        transform: translate(4.0vw,-10.5vh);\n    }\n\n    #vertical-2{\n        transform: translate(7.1vw,-9vh);\n    }\n\n    .howtoTextRight{\n        transform: translate(-3.9vw,-9vh);\n    } */\n\n}\n\n@media only screen and (min-width:2560px){\n    /* #vertical-1{\n        transform: translate(3.0vw,-7.5vh);\n    }\n\n    .howtoTextLeft{\n        transform: translate(3.0vw,-7.5vh);\n    }\n\n    #vertical-2{\n        transform: translate(5.4vw,-6.5vh);\n    }\n\n    .howtoTextRight{\n        transform: translate(-2.9vw,-7vh);\n    } */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"howtoContainer": `sectionComoFunciona_howtoContainer__81olc`,
	"howtoTextTitle": `sectionComoFunciona_howtoTextTitle__AjuZ5`,
	"howtoSearchbar": `sectionComoFunciona_howtoSearchbar__OUZPp`,
	"imgBarraPesquisa": `sectionComoFunciona_imgBarraPesquisa__F83ZQ`,
	"howtoTextCenter": `sectionComoFunciona_howtoTextCenter__aPx7h`,
	"howtoImageMap": `sectionComoFunciona_howtoImageMap__Eo2n9`
};
export default ___CSS_LOADER_EXPORT___;
